import { axiosRequest } from '@/util/axios-request'

const method = 'get'
const getTable = '/web/Job_title/list'
const getAllLis = '/web/Job_title/allList'
const create = '/web/Job_title/create'
const edit = '/web/Job_title/edit'
const del = '/web/Job_title/del'
const getType = '/web/Job_title/jobTitleType'
const getCsrfToken = '/web/job_title_grade_and_rank/getInit'
const getJobLeave = '/web/job_title_grade_and_rank/getGradeList'
const delJobLeave = '/web/job_title_grade_and_rank/delGrade'
const saveLeave = '/web/job_title_grade_and_rank/saveRank'
const getLeave = '/web/job_title_grade_and_rank/getRankList'
const delRank = '/web/job_title_grade_and_rank/delRank'
const saveGrade = '/web/job_title_grade_and_rank/saveGrade'

export const getTableFn = params => axiosRequest({ url: getTable, method, params })

// 获取职位列表
export const getAllListFn = () => axiosRequest({ url: getAllLis, method })

export const createFn = data => axiosRequest({ url: create, data })

export const editFn = data => axiosRequest({ url: edit, data })

export const delFn = data => axiosRequest({ url: del, data })

export const getTypeFn = params => axiosRequest({ url: getType, method, params })

export const getCsrfTokenFn = () => axiosRequest({ url: getCsrfToken })

// 获取职等
export const getJobLeaveFn = () => axiosRequest({ url: getJobLeave })

// 删除职等
export const delJobLeaveFn = data => axiosRequest({ url: delJobLeave, data })

// 保存职级
export const saveLeaveFn = data => axiosRequest({ url: saveLeave, data })

// 获取职级

export const getLeaveFn = data => axiosRequest({ url: getLeave, data })

// 删除职级
export const delRankFn = data => axiosRequest({ url: delRank, data })

// 保存职等

export const saveGradeFn = params => axiosRequest({ url: saveGrade, params })
